// extracted by mini-css-extract-plugin
module.exports = {"filter":"_8a0c992","label":"_d17de91"};